import { render, staticRenderFns } from "./df-modal.vue?vue&type=template&id=074a39ab&"
import script from "./df-modal.ts?vue&type=script&lang=ts&"
export * from "./df-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports